import { createSlice} from '@reduxjs/toolkit';
import { fetchPaydOrdersByUser,fetchPriceImageForPaydOrder } from '../../services/';
import { PaydOrdersState } from '../../components/interfaces';

const initialState: PaydOrdersState = {
  orders: [],
  status: 'idle',
  error: null,
  total: 0,
  imageAndPriceByKey: {},
  imageStatusByKey: {},
  imageErrorByKey: {},
};

const paydOrdersSlice = createSlice({
  name: 'paydOrders',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaydOrdersByUser.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchPaydOrdersByUser.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.orders = action.payload.orders;
        state.total = action.payload.total;
      })
      .addCase(fetchPaydOrdersByUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      })
      .addCase(fetchPriceImageForPaydOrder.pending, (state, action) => {
        const { productId, material } = action.meta.arg;
        const key = `${productId}-${material}`;
        state.imageStatusByKey[key] = 'loading';
        state.imageErrorByKey[key] = null;
      })
      .addCase(fetchPriceImageForPaydOrder.fulfilled, (state, action) => {
        const { productId, material, materialPrice } = action.payload;
        const key = `${productId}-${material}`;
        state.imageAndPriceByKey[key] = materialPrice;
        state.imageStatusByKey[key] = 'succeeded';
      })
      .addCase(fetchPriceImageForPaydOrder.rejected, (state, action) => {
        const { productId, material } = action.meta.arg;
        const key = `${productId}-${material}`;
        state.imageStatusByKey[key] = 'failed';
        state.imageErrorByKey[key] = action.error.message || 'Unknown error';
      });
  },
});

export default paydOrdersSlice.reducer;
